/* eslint eqeqeq: 'off' */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import * as workOrderActions from 'action/workorderAction';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';




export function getPlacesList() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_employee_Zones).then(response => {
            if(response != null && response != undefined)
             dispatch(actionToStoreSuccess(response,types.GET_FACILITY_PLACES_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }

 export function getRequestsList() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_employee_Requests).then(response => {
            if(response != null && response != undefined && response.length > 0)
            dispatch(actionToStoreSuccess(response,types.GET_FACILITY_REQUESTS_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}


// export function GetTenantUserContext(username) { 
//     return function (dispatch) {
//         return APIutil.getDataAPI(url.get_Tenant_Employees+"/UserContext/"+username).then(response => {
//             dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_LIST_SUCCESSFULL)); 
//         }).catch(error => {
//           throw error;
//       })
//     }
// }


//Get Employee login logo

export function GetEmployeeLoginLogo() { 
    return function (dispatch) {
        return APIutil.getImage(url.Invoice_logo).then(response => {
            const fileReaderInstance = new FileReader();
            if(response !== undefined)
            if(response.status == 200 ){
                fileReaderInstance.readAsDataURL(response.data); 
                fileReaderInstance.onload = () => {
                   var base64data = fileReaderInstance.result;     
                  dispatch(actionToStoreSuccess(base64data,types.GET_EMPLOYEE_LOGIN_LOGO));
                }
            }
        }).catch(error => { throw error; })
    }
}

//Retrieve Temperature Widget Details
export function GetTemperatureWidgetDetails(ZoneID) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Temperature_widget_details + ZoneID + '/temperature').then(response => {
           if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_TEMPERATURE_WIDGET_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

export function SaveTemperature (data) {
    return function (dispatch) {
        return APIutil.postData(url.get_Temperature_adjustments_list, data).then(response => {
            dispatch(actionToStoreSuccess(response,types.POST_TEMPERATURE_WIDGET_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

//New Facility Login - Fetch Particular Employee Details
export function GetEmployeeDetail(){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_Tenant_Employees).then(response => {
            dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_DETAILS));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetEmployeeTenantDetail(employeeID){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_Tenant_Employees_By_ID+employeeID).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined){
                dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_TENANT_DETAILS));
            }
        }).catch(error => {
            throw error;
        })
    }
}


// Maintenance Requests


export function SaveMaintenanceRequest(data){
    return function (dispatch) {
        return APIutil.postData(url.post_WorkOrder,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetEmployeeMyRequets());
                dispatch(workOrderActions.GetWorkorderList());
        }).catch(error => { throw error; })
    }
}

export function UpdateMaintenanceRequest(data,id){
    return function(dispatch){
        return APIutil.editDataAPI(url.post_WorkOrder+"/"+id,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)  
                dispatch(GetEmployeeAllRequests());
                dispatch(workOrderActions.GetWorkorderList());
        }).catch(error => {throw error;})
    }
}

export function  GetEmployeeMyRequets(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_employee_MyRequests).then(response => {
             dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_MYREQUESTS));
        }).catch(error =>{
            throw error;
        })
    }
}


export function  GetEmployeeAllRequests(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_employee_AllRequests).then(response => {
             dispatch(global_error_handling(response));
           if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_ALLREQUESTS));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetTenantOriginById(tenantId){
    return function (dispatch){
        return APIutil.getDataAPI(url.put_Tenant_Employees+'tenant/'+tenantId).then(response => {
            dispatch(actionToStoreSuccess(response,types.GET_EMPLOYEE_TENANT_ORIGIN));
        }).catch(error => {
            throw error;
        })
    }
}


/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking it type and updates the state. */

 export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}
